export enum confirmationTypes {
  QRCode = 'ga_qr',
  SMSCode = 'ga_secret_sms',
}
